import SA           from 'video/stand_alone_player.js';
import $            from 'jquery';

require('video/ref_video.css');

window.videoConfigData = [];
window.SA = SA;
document.addEventListener('DOMContentLoaded', () => {
  /*=== Creating Video Player Component ===*/
  	let $videoConfigEle = $('.video-container, .multimedia'),
		mediaGalleryFlag = true;
	window.videoPlayer = new Array($videoConfigEle.length);
	$videoConfigEle.each(function(index, el) {
		videoConfigData.push($(this).data());
	});
	if($('.video-container').length > 0){
		$('.video-container').each(function(i, el) {
			videoPlayer[i] = new SA();
			videoPlayer[i].create(el, i);
		});
	}
	$('.multimedia_link, .galleryLink').on('click', function() {
		if(mediaGalleryFlag){
			let newIndex = $videoConfigEle.length - $('.video-container').length;
			if($('.video-container').length === 0){
				newIndex = 0;
			}
			$('.multimedia').each(function(index, el) {
				videoPlayer[newIndex] = new SA();
				videoPlayer[newIndex].create(el, newIndex);
				newIndex = newIndex +1;
				mediaGalleryFlag = false;
			});
		}
	});
});


/** WEBPACK FOOTER **
 ** ./modules/video/reference_video_entry.js
 **/